import React from 'react';
import {Platform} from 'react-native';
import PlatformWorld from 'components/World/PlatformWorld';
import {useLessonViewerUnityOnLegacyMessage} from './lessonViewerUnityBridge';

/**
 * Default WebGL scene behind lesson UI (must exist under `public/unity/{WEB_SCENES_VERSION}/`).
 * Default AI tutor display name / Unity `setup_ai_tutor` id: see `LCV_DEFAULT_AI_TEACHER_NAME`
 * in `lessonViewerUnityBridge.js` (spaces → underscores, e.g. Benjamin_Franklin).
 */
export const LCV_UNITY_LEVEL = 'science_lab';

function resolveLcvUnityLocation() {
  let loc = LCV_UNITY_LEVEL;
  if (typeof window !== 'undefined') {
    const q = new URLSearchParams(window.location.search).get('lcvWorld');
    const raw = q != null ? String(q).trim() : '';
    if (raw && /^[a-zA-Z0-9_-]+$/.test(raw)) {
      loc = raw;
    }
  }
  return loc;
}

/**
 * Web: Unity iframe behind LCV via PlatformWorld. Native: CSS gradient only.
 * Wrapper uses `pointer-events: none` (CSS) so lesson UI above receives taps.
 *
 * Optional override: `?lcvWorld=<levelFolder>` (alphanumeric + _ - only).
 */
const LessonViewerUnityBackground = () => {
  const location = resolveLcvUnityLocation();
  const onLegacyMessage = useLessonViewerUnityOnLegacyMessage(location);

  if (Platform.OS !== 'web') {
    return <div className="lcv-metaverse-bg" />;
  }

  return (
    <>
      <div className="lcv-unity-bg" aria-hidden>
        <PlatformWorld location={location} onLegacyMessage={onLegacyMessage} />
      </div>
      <div className="lcv-metaverse-scrim" aria-hidden />
    </>
  );
};

export default LessonViewerUnityBackground;
